import firebase from 'firebase';

const firebaseApp = firebase.initializeApp({
  apiKey: "AIzaSyB6DPjibUibb5TzT7vy1Dsz-JItDRXe7pg",
  authDomain: "reactjs-chatting-app.firebaseapp.com",
  projectId: "reactjs-chatting-app",
  storageBucket: "reactjs-chatting-app.appspot.com",
  messagingSenderId: "657549760324",
  appId: "1:657549760324:web:95f3a18668a6d9fdca2911"
})

const db = firebaseApp.firestore();

const auth = firebase.auth();

export { db, auth }
